import React, { useEffect } from 'react';
import queryString from 'query-string';
import { H } from 'highlight.run';

import { getAnonymousId } from './utils/segment';
import { EmbedPlayer } from 'src/dashboard/embed/player';
import { NotificationMessage } from 'src/common/notification/message';

function EmbedApp() {
  const identifyAnonymousUser = () => {
    // Grab the uuid from segment if available
    const anonymousId = getAnonymousId();
    // Highlight identify
    H.identify &&
      H.identify(anonymousId, {
        id: anonymousId,
      });
  };

  useEffect(() => {
    H.init(process.env.HIGHLIGHT_KEY_PLAYER, {
      environment: process.env.ENVIRONMENT,
    });

    identifyAnonymousUser();
  }, []);

  const queryParams = queryString.parse(window.location.search);
  const uuid = document.getElementsByTagName('body')[0].getAttribute('data-uuid');

  const trackingUUID = queryParams.tracking_uuid_override || null;

  return (
    <>
      <NotificationMessage />
      <EmbedPlayer
        uuid={uuid}
        trackingUUID={trackingUUID}
        startNodeId={queryParams.start || null}
        previewMode={queryParams.preview}
        galleryMode={queryParams.gallery}
        token={queryParams.token}
      />
    </>
  );
}

export default EmbedApp;
